import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import React, { useContext, useState, useEffect } from "react";
import EditorJs from "../../Components/Editor";
import Repo from "../../Utility/Repo";
import ModalComponent from "../../Components/ModalComponent";
import { TokenContext } from "../../Components/TokenContext";
import { useCookies } from "react-cookie";
import { Button } from "design-react-kit";

function SubscriptionDetailFamiglieAffidatarie({
  userSubscriptions,
  toggleModalShowFile,
  toggleModalAdd,
  toggleModalMinori,
  setFile,
  setFileSettings,
  setshowModalModify,
  isOperator,
}) {
  const [cookies] = useCookies();
  const apiToken = useContext(TokenContext);
  const [dettaglio, setDettaglio] = useState();
  const [fileB64, setFileB64] = useState(false);
  const [showModalFile, setShowModalFile] = useState(false);
  const [firstTime, setFirstTime] = useState(true);

  const bodyFile = () => {
    return (
      <object
        width="100%"
        height="900"
        data={fileB64 ? `data:application/pdf;base64,${fileB64}` : undefined}
        type="application/pdf"
      ></object>
    );
  };

  const handleCloseModalFile = () => {
    window.location.reload();
  };

  useEffect(() => {
    if (firstTime && userSubscriptions?.dettagli) {
      setDettaglio(userSubscriptions.dettagli);
    } else {
      setDettaglio(`
<p style="text-align:center;">UFFICIO SERVIZI SOCIALI</p>
<p><strong>Oggetto:</strong></p>
<p><strong>Servizio proponente: </strong>Servizio Sociale Professionale di Ambito operante nel Comune di ${cookies.user_profile.AreaName}.</p>
<p><strong>Analisi della situazione</strong></p>
<p><strong>Obiettivo generale</strong></p>
<p><strong>Obiettivi specifici</strong></p>
<p><strong>Metodologia</strong></p>
<p><strong>Soggetti pubblici e privati</strong></p>
<p><strong>Verifica dei risultati</strong></p>
<p><strong>Modalità di espletamento del Servizio</strong></p>
<p><strong>Tempi</strong></p>
<p style="text-align:right;">${cookies.user_profile.AreaName},</p>
<p style="text-align:right;">Assistente Sociale</p>
`);
    }
    setFirstTime(false);
  }, [userSubscriptions]);

  const controlloMinori = () => {
    const annoCorrente = new Date().getFullYear().toString();
    const minoriAnnoCorrente =
      userSubscriptions?.subscriptionComponentiNucleoFamiliare?.filter(
        (componente) => {
          let annoMaggiorenne = "";
          if (componente.dataMaggiorenne) {
            if (componente.dataMaggiorenne.length >= 4) {
              if (componente.dataMaggiorenne.includes("-")) {
                annoMaggiorenne = componente.dataMaggiorenne.substring(0, 4);
              } else if (componente.dataMaggiorenne.includes("/")) {
                annoMaggiorenne = componente.dataMaggiorenne.split("/")[2];
              } else {
                annoMaggiorenne = componente.dataMaggiorenne.substring(0, 4);
              }
            }
          }
          return annoMaggiorenne === annoCorrente;
        },
      );
    if (minoriAnnoCorrente && minoriAnnoCorrente?.length > 0) {
      const nomiMinori = minoriAnnoCorrente
        .map((c) => c.componenteNomeCompleto)
        .join(", ");
      return (
        <div className="alert alert-warning my-2">
          Attenzione:{" "}
          {minoriAnnoCorrente?.length > 1 ? "I minori" : "Il minore"}{" "}
          <b>{nomiMinori}</b>{" "}
          {minoriAnnoCorrente?.length > 1 ? "compiono" : "compie"} la{" "}
          <b>maggiore età</b> nell'
          <b>anno in corso</b>!
        </div>
      );
    }
    return null;
  };

  return (
    <>
      <div className="row no_print">
        <div className="col-lg-12 mt-3">
          <div className="card-wrapper card-space">
            <div className="card card-bg no-after card-big roundedCustom">
              <div className="card-body">
                {controlloMinori()}
                <h4>Relazione</h4>
                <div className="mb-4">
                  {isOperator ? (
                    <>
                      {userSubscriptions?.state === "ADDED" && (
                        <div className="alert alert-info mt-2">
                          In attesa della richiesta scritta da parte
                          dell’utente, del provvedimento e della determina di
                          concessione, a cura dell’operatore comunale.
                        </div>
                      )}
                      {userSubscriptions?.state === "LOADED" && (
                        <div className="row align-items-center justify-content-center">
                          <button
                            type="button"
                            className="btn btn-primary text-success w-50 p-2 py-3"
                            onClick={() => {
                              setshowModalModify(true);
                            }}
                          >
                            <svg className="icon icon-white">
                              <use href={`${iconSprite}#it-pencil`} />
                            </svg>{" "}
                            <span className="align-middle text-white">
                              Esito Valutazione
                            </span>
                          </button>
                        </div>
                      )}
                      {userSubscriptions?.state === "VALIDATED" && (
                        <div className="alert alert-success mt-2">
                          <div className="row">
                            <strong>Validato</strong>
                            {userSubscriptions?.nProtocolloUscita && (
                              <div className="col-3">
                                N. Protocollo Uscita:{" "}
                                <strong className="ml-1">
                                  {userSubscriptions?.nProtocolloUscita}
                                </strong>
                              </div>
                            )}
                            <div className="col text-right">
                              <button
                                type="button"
                                className="btn btn-outline-primary text-success  p-2"
                                onClick={() => {
                                  setshowModalModify(true);
                                }}
                                title="Modifica iscrizione"
                              >
                                <svg className="icon icon-primary">
                                  <use href={`${iconSprite}#it-pencil`} />
                                </svg>
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      {" "}
                      {userSubscriptions?.state === "ADDED" && (
                        <div className="alert alert-info mt-2">
                          Per procedere con la revisione dell'iscrizione, è
                          necessario caricare la richiesta scritta dell’utente,
                          il provvedimento del tribunale e la determina di
                          concessione.
                        </div>
                      )}{" "}
                      {userSubscriptions?.state === "LOADED" && (
                        <div className="alert alert-info mt-2">
                          In Attesa di revisione da parte dell'ufficio di piano
                        </div>
                      )}
                      {userSubscriptions?.state === "VALIDATED" && (
                        <div className="alert alert-success mt-2">
                          <div className="row">
                            <strong>Validato</strong>
                            {userSubscriptions?.nProtocolloUscita && (
                              <div className="col-3">
                                N. Protocollo Uscita:{" "}
                                <strong className="ml-1">
                                  {userSubscriptions?.nProtocolloUscita}
                                </strong>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
                <div className="container mb-5">
                  <div className="row">
                    <div className="col-lg-12">
                      {" "}
                      <div className="container">
                        <div className="row row-cols-2 mb-4 mt-3">
                          <div className="col border-right">
                            {userSubscriptions.subscriptionFiles.filter(
                              (x) => x.description === "richiestaScritta",
                            ).length > 0 ? (
                              <>
                                {userSubscriptions.subscriptionFiles
                                  .filter(
                                    (x) => x.description === "richiestaScritta",
                                  )
                                  .map((allegatoFirmato, index) => (
                                    <div className="row" key={index}>
                                      <div className="col-10">
                                        <div className="categoryicon-top">
                                          <span className="text">
                                            <a
                                              href="#"
                                              className="text-decoration-none font-weight-bold"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                setFile({
                                                  data:
                                                    "data:application/pdf;base64," +
                                                    allegatoFirmato?.storageFile
                                                      ?.file,
                                                });
                                                toggleModalShowFile(true);
                                              }}
                                            >
                                              <svg className="icon">
                                                <use
                                                  href={`${iconSprite}#it-clip`}
                                                ></use>
                                              </svg>
                                              {allegatoFirmato.storageFile.name}
                                            </a>

                                            <br />
                                          </span>
                                        </div>
                                      </div>
                                      <div className="col-1">
                                        <button
                                          type="button"
                                          className={
                                            userSubscriptions?.state ===
                                            "VALIDATED"
                                              ? "border btn btn-outline-primary text-success  p-2"
                                              : "btn btn-outline-primary text-success  p-2"
                                          }
                                          onClick={() => {
                                            toggleModalAdd(true);
                                            setFileSettings({
                                              title: "Richiesta Scritta",
                                              description: "richiestaScritta",
                                              fileName: "richiestaScritta",
                                            });
                                          }}
                                          aria-label="Carica Richiesta Scritta"
                                          disabled={
                                            userSubscriptions?.state ===
                                            "VALIDATED"
                                          }
                                          title={
                                            userSubscriptions?.state ===
                                            "VALIDATED"
                                              ? "Non si possono apportare modifiche alle iscrizioni validate"
                                              : "Sovrascrivi Richiesta Scritta"
                                          }
                                        >
                                          <svg className="icon icon-primary">
                                            <use
                                              href={`${iconSprite}#it-upload`}
                                            />
                                          </svg>
                                        </button>
                                      </div>
                                    </div>
                                  ))}
                              </>
                            ) : (
                              <div className="align-self-center text-center">
                                <button
                                  type="button"
                                  className={
                                    userSubscriptions?.state === "VALIDATED"
                                      ? "border btn btn-outline-primary text-success  p-2"
                                      : "btn btn-outline-primary text-success  p-2"
                                  }
                                  onClick={() => {
                                    toggleModalAdd(true);
                                    setFileSettings({
                                      title: "Richiesta Scritta",
                                      description: "richiestaScritta",
                                      fileName: "richiestaScritta",
                                    });
                                  }}
                                  disabled={
                                    userSubscriptions?.state === "VALIDATED"
                                  }
                                  title={
                                    userSubscriptions?.state === "VALIDATED"
                                      ? "Non si possono apportare modifiche alle iscrizioni validate"
                                      : "Carica Richiesta Scritta dell'utente"
                                  }
                                >
                                  <svg className="icon icon-primary">
                                    <use href={`${iconSprite}#it-upload`} />
                                  </svg>{" "}
                                  <span className="align-middle">
                                    Carica Richiesta Scritta dell'utente
                                  </span>
                                </button>
                              </div>
                            )}
                          </div>
                          <div className="col">
                            {userSubscriptions.subscriptionFiles.filter(
                              (x) => x.description === "provvedimento",
                            ).length > 0 ? (
                              <>
                                {userSubscriptions.subscriptionFiles
                                  .filter(
                                    (x) => x.description === "provvedimento",
                                  )
                                  .map((allegatoFirmato, index) => (
                                    <div className="row" key={index}>
                                      <div className="col-10">
                                        <div className="categoryicon-top">
                                          <span className="text">
                                            <a
                                              href="#"
                                              className="text-decoration-none font-weight-bold"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                setFile({
                                                  data:
                                                    "data:application/pdf;base64," +
                                                    allegatoFirmato?.storageFile
                                                      ?.file,
                                                });
                                                toggleModalShowFile(true);
                                              }}
                                            >
                                              <svg className="icon">
                                                <use
                                                  href={`${iconSprite}#it-clip`}
                                                ></use>
                                              </svg>
                                              {allegatoFirmato.storageFile.name}
                                            </a>

                                            <br />
                                          </span>
                                        </div>
                                      </div>
                                      <div className="col-1">
                                        <button
                                          type="button"
                                          className={
                                            userSubscriptions?.state ===
                                            "VALIDATED"
                                              ? "border btn btn-outline-primary text-success  p-2"
                                              : "btn btn-outline-primary text-success  p-2"
                                          }
                                          onClick={() => {
                                            toggleModalAdd(true);
                                            setFileSettings({
                                              title:
                                                "Provvedimento del Tribunale",
                                              description: "provvedimento",
                                              fileName: "provvedimento",
                                            });
                                          }}
                                          aria-label="Carica il Provvedimento del Tribunale"
                                          disabled={
                                            userSubscriptions?.state ===
                                            "VALIDATED"
                                          }
                                          title={
                                            userSubscriptions?.state ===
                                            "VALIDATED"
                                              ? "Non si possono apportare modifiche alle iscrizioni validate"
                                              : "Sovrascrivi il Provvedimento del Tribunale"
                                          }
                                        >
                                          <svg className="icon icon-primary">
                                            <use
                                              href={`${iconSprite}#it-upload`}
                                            />
                                          </svg>
                                        </button>
                                      </div>
                                    </div>
                                  ))}
                              </>
                            ) : (
                              <div className="align-self-center text-center">
                                <button
                                  type="button"
                                  className={
                                    userSubscriptions?.state === "VALIDATED"
                                      ? "border btn btn-outline-primary text-success  p-2"
                                      : "btn btn-outline-primary text-success  p-2"
                                  }
                                  onClick={() => {
                                    toggleModalAdd(true);
                                    setFileSettings({
                                      title: "Provvedimento del Tribunale",
                                      description: "provvedimento",
                                      fileName: "provvedimento",
                                    });
                                  }}
                                  disabled={
                                    userSubscriptions?.state === "VALIDATED"
                                  }
                                  title={
                                    userSubscriptions?.state === "VALIDATED"
                                      ? "Non si possono apportare modifiche alle iscrizioni validate"
                                      : "Carica Provvedimento del Tribunale"
                                  }
                                >
                                  <svg className="icon icon-primary">
                                    <use href={`${iconSprite}#it-upload`} />
                                  </svg>{" "}
                                  <span className="align-middle">
                                    Carica Provvedimento del Tribunale
                                  </span>
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row mt-5">
                          <div className="col-3"></div>
                          <div className="col-6 mt-3">
                            {userSubscriptions.subscriptionFiles.filter(
                              (x) => x.description === "determinaDiConcessione",
                            ).length > 0 ? (
                              <>
                                {userSubscriptions.subscriptionFiles
                                  .filter(
                                    (x) =>
                                      x.description ===
                                      "determinaDiConcessione",
                                  )
                                  .map((allegatoFirmato, index) => (
                                    <div className="row" key={index}>
                                      <div className="col-10">
                                        <div className="categoryicon-top">
                                          <span className="text">
                                            <a
                                              href="#"
                                              className="text-decoration-none font-weight-bold"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                setFile({
                                                  data:
                                                    "data:application/pdf;base64," +
                                                    allegatoFirmato?.storageFile
                                                      ?.file,
                                                });
                                                toggleModalShowFile(true);
                                              }}
                                            >
                                              <svg className="icon">
                                                <use
                                                  href={`${iconSprite}#it-clip`}
                                                ></use>
                                              </svg>
                                              {allegatoFirmato.storageFile.name}
                                            </a>

                                            <br />
                                          </span>
                                        </div>
                                      </div>
                                      <div className="col-1">
                                        <button
                                          type="button"
                                          className={
                                            userSubscriptions?.state ===
                                            "VALIDATED"
                                              ? "border btn btn-outline-primary text-success  p-2"
                                              : "btn btn-outline-primary text-success  p-2"
                                          }
                                          onClick={() => {
                                            toggleModalAdd(true);
                                            setFileSettings({
                                              title: "Determina di Concessione",
                                              description:
                                                "determinaDiConcessione",
                                              fileName:
                                                "determinaDiConcessione",
                                            });
                                          }}
                                          aria-label="Carica Determina di Concessione"
                                          disabled={
                                            userSubscriptions?.state ===
                                            "VALIDATED"
                                          }
                                          title={
                                            userSubscriptions?.state ===
                                            "VALIDATED"
                                              ? "Non si possono apportare modifiche alle iscrizioni validate"
                                              : "Sovrascrivi Determina di Concessione"
                                          }
                                        >
                                          <svg className="icon icon-primary">
                                            <use
                                              href={`${iconSprite}#it-upload`}
                                            />
                                          </svg>
                                        </button>
                                      </div>
                                    </div>
                                  ))}
                              </>
                            ) : (
                              <div className="align-self-center text-center">
                                <button
                                  type="button"
                                  className={
                                    userSubscriptions?.state === "VALIDATED"
                                      ? "border btn btn-outline-primary text-success  p-2"
                                      : "btn btn-outline-primary text-success  p-2"
                                  }
                                  onClick={() => {
                                    toggleModalAdd(true);
                                    setFileSettings({
                                      title: "Determina di Concessione",
                                      description: "determinaDiConcessione",
                                      fileName: "determinaDiConcessione",
                                    });
                                  }}
                                  disabled={
                                    userSubscriptions?.state === "VALIDATED"
                                  }
                                  title={
                                    userSubscriptions?.state === "VALIDATED"
                                      ? "Non si possono apportare modifiche alle iscrizioni validate"
                                      : "Carica Determina di Concessione"
                                  }
                                >
                                  <svg className="icon icon-primary">
                                    <use href={`${iconSprite}#it-upload`} />
                                  </svg>{" "}
                                  <span className="align-middle">
                                    Carica Determina di Concessione
                                  </span>
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>{" "}
                {userSubscriptions?.subscriptionComponentiNucleoFamiliare
                  ?.length > 0 && (
                  <div>
                    <div className="row">
                      <div className="col">
                        <h4>Minori coinvolti:</h4>
                      </div>
                      <div className="etichettaCustom col text-right">
                        <svg
                          className="icon icon-primary align-middle mr-1"
                          style={{ verticalAlign: "middle" }}
                        >
                          <use href={`${iconSprite}#it-plus`}></use>
                        </svg>
                        <a
                          className="text-decoration-none align-middle"
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            toggleModalMinori(true);
                          }}
                        >
                          Modifica minori coinvolti
                        </a>
                      </div>
                    </div>
                    {userSubscriptions.subscriptionComponentiNucleoFamiliare.map(
                      (componente) => (
                        <div key={componente.id}>
                          <b>{componente.componenteNomeCompleto}</b> nato il{" "}
                          {componente.componenteNucleoFamiliare.dataNascita}{" "}
                          <b>
                            {componente.componenteNucleoFamiliare.codiceFiscale}
                          </b>{" "}
                          compimento maggiore età{" "}
                          <b>{componente.dataMaggiorenne}</b>
                        </div>
                      ),
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalComponent
        toggleModal={setShowModalFile}
        isOpen={showModalFile}
        header="Crea PDF Relazione"
        body={bodyFile()}
        buttonDeny="Chiudi"
        onClose={handleCloseModalFile}
      />
    </>
  );
}

export default SubscriptionDetailFamiglieAffidatarie;
